module.exports = __webpack_public_path__ + "img/oval-lightgrey.8afcd6d0.svg";